import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

// API
import { api } from "src/services/api";

// Thunks
export const userLogin = createAsyncThunk(
  "auth/login",
  async (
    { email, password }: { email: string; password: string },
    { rejectWithValue }
  ) => {
    try {
      // configure header's Content-Type as JSON
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data: getUsernameRequestData } = await api.post(
        `/api/softphone/ame/auth/get-username/`,
        { email: email },
        config
      );

      const { data: authRequestData, status } = await api.post(
        `/api/auth/token/`,
        {
          grant_type: "password",
          username: getUsernameRequestData.username,
          password,
        },

        Object.assign(
          {
            config,
          },
          {
            headers: {
              Authorization:
                "Basic ZWpLVnR1ZE5PMUZ0andmQXBSUTBDclQ3ZXZkY2xudXZ1TnZ6ZHNZQjpDUjhaUFFkWmZLdFdLR3Q2cmN3SU9VTVVvVHUwVnF0Y0d6NFJGT3R0dUJrNVVqV3RWbXZTMzR5NjROQVduZDhnYzJvZzVBUkl1V0xHRkV3dHRyS2hrYnlETXBKaUU4UEl0SUVINlBpa25ickt4YU1rQjBNcThoekE1NmlxYmYyZw==",
            },
          }
        )
      );

      if (status == 200) {
        return { ...authRequestData, email };
      }

      return rejectWithValue("Usuário ou senha inválidos");
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error.status === 401)
          return rejectWithValue("Usuário ou senha inválidos");

        // return custom error message from API if any
        if (error.response && error.response.data.message) {
          return rejectWithValue(error.response.data.message);
        } else {
          return rejectWithValue(error.message);
        }
      }

      return rejectWithValue("Unexpect error");
    }
  }
);

export const userLogout = createAsyncThunk(
  "auth/logout",
  async (manualLogout: boolean) => {
    try {
      const result = await api.delete(
        `/api/softphone/ame/atendimento/atendente/login/`
      );

      return { success: true, manualLogout };
    } catch (ex) {
      return { success: true, manualLogout };
    }
  }
);

export const getPaDetails = async () => {
  const defaultMessage = 'Falha ao obter dados da PA.';

  try {
    const { data: authRequestData, status } = await api.get(
      `/api/softphone/ame/atendente/`
    );

    if (status == 200) {
      return { success: true, data: authRequestData };
    }

    return {
      success: false,
      message: `${defaultMessage} Erro ${status}`
    };
  } catch (error) {
    return {
      success: false,
      message: `${defaultMessage}`
    };
  }
};

export const sendRecoveryRequest = async (email: string) => {
  try {
    const { data: recoveryRequestData, status } = await api.post(
      `/api/softphone/ame/auth/password-recovery/`,
      { email }
    );

    if (status == 201) {
      return { success: true, data: recoveryRequestData };
    }

    return {
      success: false,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};
